import {apiRequest} from "../helpers/utils";

export const campaignServices = {
    read,
    create,
    update,
    archive,
    find,
    restore,
    updateCost,
    bulkCampaignUpdate
};

function read({name, trafficSourceId, campaignIds}) {
    let params = {
        name,
        trafficSourceId,
        campaignIds,
        isDeleted: false,
        isActive: true,
        pageSize: 50
    };
    return apiRequest("get", "v1/campaign", {}, params);
}

function create(formData) {
    return apiRequest("post", "v1/campaign", formData);
}

function update(id, formData) {
    return apiRequest("put", "v1/campaign/" + parseInt(id), formData);
}

function archive(formData) {
    return apiRequest("post", "v1/campaign/archive", formData);
}

function restore(formData) {
    return apiRequest("post", "v1/campaign/restore", formData);
}

function find(id) {
    return apiRequest("get", "v1/campaign/" + parseInt(id));
}

function updateCost(formData) {
    return apiRequest("post", "v1/campaign/cost", formData);
}

function bulkCampaignUpdate(formData) {
    return apiRequest("patch", "v1/campaign", formData);
}
